module.exports = __webpack_public_path__ + "img/chandarzi.cf707160.jpg";